import React from 'react';

import { useInvertedLocalize } from '../../../../../shared/hooks';

import './ComplianceScoreChip.css';

interface ComplianceScoreChipProps {
  score: number;
  label: string;
}

/**
 * Compliance Score Chip component displaying a circular progress indicator
 */
function ComplianceScoreChip({
  score,
  label,
}: ComplianceScoreChipProps): React.ReactElement {
  const localize = useInvertedLocalize();
  // Calculate the circular progress arc
  const radius = 14;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (score / 100) * circumference;

  return (
    <div className='complianceScoreChip'>
      <div className='complianceScoreChipMeter'>
        <svg className='complianceScoreChipMeterSvg' viewBox='0 0 32 32'>
          {/* Background circle */}
          <circle
            cx='16'
            cy='16'
            r='14'
            fill='none'
            stroke='#373840'
            strokeWidth='4'
            strokeLinecap='round'
          />
          {/* Progress circle */}
          <circle
            cx='16'
            cy='16'
            r='14'
            fill='none'
            stroke='#f6a6a4'
            strokeWidth='4'
            strokeLinecap='round'
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            transform='rotate(-90 16 16)'
            style={{ transition: 'stroke-dashoffset 0.3s ease' }}
          />
        </svg>
        <span className='complianceScoreChipPercentage'>
          {score}
          {localize('%')}
        </span>
      </div>
      <span className='complianceScoreChipLabel'>{label}</span>
    </div>
  );
}

export default ComplianceScoreChip;
